import { ITooltipBehavior } from "./ITooltipBehavior";

export interface ITooltipBehaviorSpecifiable {
  tooltipBehavior: ITooltipBehavior;
}

export function instanceOfITooltipBehaviorSpecifiable(instance: any): instance is ITooltipBehaviorSpecifiable {
  return instance
    && (instance.tooltipBehavior !== undefined);
}
